import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { GameDialog } from './GameDialog.jsx'
import { MetaTags } from '../Layout/MetaTags.jsx'

export class GameDetails extends React.Component {


    constructor(props) {
        super(props);

        let getGameName = function (props) {
            // stari način
            var gameName = props.route.location.query && props.route.location.query.game;
            //novi način
            if (!gameName)
                gameName = props.route.match && props.route.match.params && props.route.match.params.gameName;

            if (!gameName && props.igra) {
                gameName = casino.utils.normalizeString(props.igra.n);
            }
            return gameName;
        }

        let getProviderName = function (props) {
            var providerName = props.route.match && props.route.match.params && props.route.match.params.providerName;
            if (!providerName && props.brandName)
                providerName = props.brandName;
            return providerName
        }

        this.state = {
            doClose: false,
            getGameName,
            getProviderName,
            igre: null, 
            categories: null
        }

        this.overlayTouchMove = this.overlayTouchMove.bind(this);
        this.gameTouchStart = this.gameTouchStart.bind(this);
        this.gameTouchMove = this.gameTouchMove.bind(this);
        this.gameTouchEnd = this.gameTouchEnd.bind(this);
        this.gameDiv = React.createRef();
        this.overlayDiv = React.createRef();
        this.setData = this.setData.bind(this);
        this.routeRedirect = this.routeRedirect.bind(this);
    }

    overlayTouchMove(event) {
        event.preventDefault();
    }
    gameTouchStart(event) {
        var gameDiv = this.gameDiv.current;

        var touch = event.targetTouches[0];
        this._start = touch.pageY;
        this._end = -1;
        gameDiv.className = gameDiv.className + " no-animation";
    }
    gameTouchMove(event) {
        var gameDiv = this.gameDiv.current;

        var touch = event.targetTouches[0];
        this._end = touch.pageY;
        var diff = this._end - this._start;

        if (diff > 0) {
            gameDiv.style.transform = 'translate3d(50%,' + diff + 'px,0)';
        } else {
            gameDiv.style.transform = 'translate3d(50%,0px,0)';
        }

        event.preventDefault();

    }
    gameTouchEnd(event) {
        var gameDiv = this.gameDiv.current;

        gameDiv.className = gameDiv.className.replace("no-animation", "").trim();
        gameDiv.style.transform = null;

        if (this._end > -1 && (this._end - this._start) > 100) {
            this.setState({ doClose: true });
        }
    }
    componentDidMount() {
        var forceMoneyPlay = this.props.route.location.query && this.props.route.location.query.forceMoneyPlay;
        if (!forceMoneyPlay) {
            this._start = -1, this._end = -1;

            var gameDiv = this.gameDiv.current;
            var overlayDiv = this.overlayDiv.current;


            // zabranimo scrolanje backgounda
            overlayDiv.addEventListener('touchmove', this.overlayTouchMove, false);

            // postavimo evente na prozor od igre
            gameDiv.addEventListener('touchstart', this.gameTouchStart, false);
            gameDiv.addEventListener('touchmove', this.gameTouchMove, false);
            gameDiv.addEventListener('touchend', this.gameTouchEnd, false);
        }
        if (this.props.loadGames) {
            var promises = Promise.all([casino.repos.gameRepo.list().then(this.props.unpackGamesListFn), casino.repos.categoryRepo.list().then(this.props.saveCategoriesFn)]);
            this.dataPromises = casino.utils.makeCancelablePromise(promises);
            this.dataPromises.promise.then(this.setData, function (reason) { });
        }
    }

    setData(data) {
        var [igre, kategorije] = data;
        this.setState({
            igre: igre,
            categories: kategorije.items,
        });
        this.props.showLoadingFn(false);
    }

    componentWillUnmount() {
        var forceMoneyPlay = this.props.route.location.query && this.props.route.location.query.forceMoneyPlay;
        if (!forceMoneyPlay) {
            var gameDiv = this.gameDiv.current;
            var overlayDiv = this.overlayDiv.current;

            overlayDiv.removeEventListener('touchmove', this.overlayTouchMove);
            gameDiv.removeEventListener('touchstart', this.gameTouchStart);
            gameDiv.removeEventListener('touchmove', this.gameTouchMove);
            gameDiv.removeEventListener('touchend', this.gameTouchEnd);
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let gameName = prevState.getGameName(nextProps);

        if (gameName != prevState.gameName)
            return { doClose: false };

        return {};
    }

    routeRedirect() {
        this.props.route.history.push(this.props.routeRedirect);
    }

    componentDidUpdate(prevState) {
        let gameName = this.state.getGameName(this.props);
        if (this.state.gameName != gameName)
            this.setState({ gameName });

        if (this.state.doClose && !prevState.doClose) {
            this.props.route.history.push(this.props.routePrefix || '/');
        }
    }

    absolutePath(href) {
        var link = document.createElement("a");
        link.href = href;
        return link.href.toLowerCase();
    }

    // #region GamePosition Logika, HizmanB

    // Glavna helper metoda za dohvaćanje vrijednosti, HizmanB
    getValue = (key, defaultValue = "") => {
        const { props } = this;
        return props.route?.location?.query?.[key] ?? props[key] ?? defaultValue;
    };

    // Metode koje koriste getValue, HizmanB
    getPageName = () => this.getValue("PageName", null);
    getPositionType = () => this.getValue("PositionType", "");
    getComponentName = () => this.getValue("ComponentName", "");
    getComponentPosition = () => this.getValue("ComponentPosition", null);
    getBannerName = () => this.getValue("BannerName", "");
    getBannerPosition = () => this.getValue("BannerPosition", null);
    getTabName = () => this.getValue("TabName", "");
    getSliderName = () => this.getValue("SliderName", "");

    getIsIcon = () => {
        const val = this.getValue("IsIcon", false);
        return val === "true" || val === true;
    };

    getGamePosition = () => parseInt(this.getValue("GamePosition", 1)) || 1;
    getTabPosition = () => parseInt(this.getValue("TabPosition", null)) || null;
    getSliderPosition = () => parseInt(this.getValue("SliderPosition", null)) || null;
    getBannerPosition = () => parseInt(this.getValue("BannerPosition", null)) || null;


    getFilterValue = () => {
        const searchVal = this.getValue("SearchValue", "");
        let filterSource = this.getValue("FilterValue", null);

        if (typeof filterSource === "string") {
            try {
                filterSource = JSON.parse(filterSource);
            } catch (e) {
                filterSource = null;
            }
        }

        const formatWithBrackets = (value, type = "") => {
            if (!value) return "";

            return value
                .split(',')
                .filter(item => item.trim() !== "")
                .map(item => {
                    const cleanItem = item.trim();
                    let finalValue = cleanItem;

                    if (type === "odabrano") {
                        finalValue = casino.utils.getFilterOdabranoName(cleanItem);
                    }
                    else if (type === "provideri") {
                        const brand = this.props.brands?.[cleanItem];
                        finalValue = brand ? brand.name : cleanItem;
                    }

                    return `{${finalValue}}`;
                })
                .join(',');
        };

        return {
            Search: filterSource?.Search || searchVal,
            Kategorije: formatWithBrackets(filterSource?.Kategorije),
            Provideri: formatWithBrackets(filterSource?.Provideri, "provideri"),
            Teme: formatWithBrackets(filterSource?.Teme),
            Odabrano: formatWithBrackets(filterSource?.Odabrano, "odabrano")
        };
    };

    getAllPositionData() {
        const { props, state } = this;
        return {
            pageName: this.getPageName(),
            gamePosition: this.getGamePosition(),
            positionType: this.getPositionType(),
            componentName: this.getComponentName(),
            componentPosition: this.getComponentPosition(),
            bannerName: this.getBannerName(),
            bannerPosition: this.getBannerPosition(),
            isIcon: this.getIsIcon(),
            tabName: this.getTabName(),
            tabPosition: this.getTabPosition(),
            sliderName: this.getSliderName(),
            sliderPosition: this.getSliderPosition(),
            filter: this.getFilterValue()
        };
    };
    // #endregion

    render() {
        let gameName = this.state.getGameName(this.props);
        let providerName = this.state.getProviderName(this.props);

        // Poziv GamePosition logike da popuni i validira podatke o poziciji kliknutog elementa, HizmanB
        const { pageName, gamePosition, positionType, componentName,
            componentPosition, bannerName, bannerPosition, isIcon,
            tabName, tabPosition, sliderName, sliderPosition, filter } = this.getAllPositionData();

        var forceMoneyPlay = this.props.route.location.query && this.props.route.location.query.forceMoneyPlay;
        var game = null;

        if (gameName && this.props.loadGames && this.state.igre) {
            game = providerName != null ? this.state.igre.filter(igra => casino.utils.normalizeString(igra.n) == gameName && this.props.brands[igra.bID].nameNormalizirano == providerName.toLowerCase())[0]
                : this.state.igre.filter(igra => casino.utils.normalizeString(igra.n) == gameName)[0];
        } else if (this.props.igre) {
            game = providerName != null ? this.props.igre.filter(igra => casino.utils.normalizeString(igra.n) == gameName && this.props.brands[igra.bID].nameNormalizirano == providerName.toLowerCase())[0]
                : this.props.igre.filter(igra => casino.utils.normalizeString(igra.n) == gameName)[0];
        }

        // ako želimo forsirati direktan ulazak u igru onda ne treba dijalog/ovelay
        if (forceMoneyPlay)
            if (game)
                return <GameDialog brands={this.props.brands} key={game.s} igra={game} forceMoneyPlay={forceMoneyPlay} {...this.props} urlParam={this.props.urlParam}/>;
            else
                return null;

        let description = game && "Zaigraj " + game.n + " u SuperSport CASINU!";

        if (game && game.opis)
            description = game.opis;

        let imgSrc = game && (casino.config.gameImagesUrl + this.props.brands[game.bID].nameNormalizirano + '/' + casino.utils.normalizeString(game.n) + (casino.config.canIUseWebP ? '.webp' : '.jpeg'));
        // dialog i sve
        return (
            <div>
                {game && <MetaTags title={game.n + " - Casino | Najbolji Online Casino u Hrvatskoj | SuperSport | SuperCasino"} description={description} image={imgSrc} />}


                <div ref={this.gameDiv} className={game ? "game-dialog active landscape-max-65" : "game-dialog landscape-max-65"}>
                    <div className="game-dialog--inner">
                        <div className="game-dialog--outer">
                            <GameDialog
                                igra={game}
                                {...this.props}
                                brands={this.props.brands}
                                urlParam={this.props.urlParam}
                                // GamePosition podaci, HizmanB
                                trackingData={{
                                    pageName,
                                    gamePosition,
                                    positionType,
                                    componentName,
                                    componentPosition,
                                    bannerName,
                                    bannerPosition,
                                    isIcon,
                                    tabName,
                                    tabPosition,
                                    sliderName,
                                    sliderPosition,
                                    filter
                                }}
                            />
                        </div>
                    </div>
                    <NavLink to={this.props.routePrefix || '' + '/'} className="close-overlay "></NavLink>
                </div>

                <div ref={this.overlayDiv} className={game ? "modal-dialog-overlay active" : "modal-dialog-overlay"}>
                    <NavLink to={this.props.routePrefix || '' + '/'}></NavLink>
                </div>
            </div>
        );
    }
};
